// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__QXDtE","item":"styles_item__U9fHN","elipsis":"styles_elipsis__yqzdX","arrow":"styles_arrow__Y8acB","active":"styles_active__VEoGp"};